<template>
  <b-modal
    v-model="showModal"
    title="Add Issued Cheque"
    size="lg"
    class="m-4"
    no-close-on-backdrop
    @hidden="$emit('modal-closed')"
    @ok="submitHandler"
  >
    <b-form
      @submit.prevent="submitHandler"
    >
      <b-row>
        <b-col cols="12">
          <b-alert
            variant="danger"
            :show="errorMessage ? true : false"
          >
            <div
              v-if="typeof errorMessage === 'string'"
              class="alert-body"
            >
              <p>
                {{ errorMessage }}
              </p>
            </div>
            <div
              v-else-if="errorMessage.detail"
              class="alert-body"
            >
              <p>
                {{ errorMessage.detail }}
              </p>
            </div>
            <div
              v-else-if="errorMessage.non_field_errors"
              class="alert-body"
            >
              <p>
                {{ errorMessage.non_field_errors[0] }}
              </p>
            </div>
            <div
              v-else-if="errorMessage.message"
              class="alert-body"
            >
              <p>
                {{ errorMessage.message }}
              </p>
            </div>

          </b-alert>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="Number of Cheques"
            label-for="noCheques"
          >
            <b-form-input
              id="noCheques"
              v-model="noCheques"
              type="number"
              min="1"
              placeholder="Number of Cheques"
            />
            <p
              v-if="errorMessage && errorMessage.no_of_cheques"
              class="error-message"
            >
              {{ errorMessage.no_of_cheques[0] }}
            </p>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <div
            class="form-group text-center d-flex align-items-center justify-content-center"
            style="height: 100%;"
          >
            <label
              class="font-weight-bold mb-0"
              style="font-size: 16px;"
            >
              Cheque Number : {{
                defaultChequeNumber && noCheques == 1
                  ? defaultChequeNumber
                  : defaultChequeNumber && noCheques > 1
                    ? `${defaultChequeNumber} -> ${String(parseInt(defaultChequeNumber, 10) + parseInt(noCheques, 10) - 1).padStart(defaultChequeNumber.length, '0')}`
                    : ''
              }}
            </label>
          </div>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="Supplier"
          >
            <custom-v-select
              id="supplier"
              v-model="selectedSupplier"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="supplierOptions"
              label="text"
            />
            <p
              v-if="errorMessage && errorMessage.supplier"
              class="error-message"
            >
              {{ errorMessage.supplier[0] }}
            </p>
          </b-form-group>
        </b-col>

        <b-col
          cols="6"
        >
          <label for="issue-date">Issue Date</label>
          <b-form-datepicker
            id="issue-date"
            v-model="issueDate"
            menu-class="w-100"
            calendar-width="100%"
          />
          <p
            v-if="errorMessage && errorMessage.issue_date"
            class="error-message"
          >
            {{ errorMessage.issue_date[0] }}
          </p>
        </b-col>

        <b-col
          v-if="noCheques == 1"
          cols="6"
        >
          <b-form-group
            label="Amount"
            label-for="amount"
          >
            <b-form-input
              id="amount"
              v-model="amount"
              type="number"
              step="0.01"
              placeholder="Amount"
            />
            <p
              v-if="errorMessage && errorMessage.amount"
              class="error-message"
            >
              {{ errorMessage.amount[0] }}
            </p>
          </b-form-group>
        </b-col>

        <b-col
          v-if="noCheques == 1"
          cols="6"
        >
          <b-form-group
            label="Upto Amount"
            label-for="uptoAmount"
          >
            <b-form-input
              id="uptoAmount"
              v-model="uptoAmount"
              type="number"
              step="0.01"
              placeholder="Upto Amount"
            />
            <p
              v-if="errorMessage && errorMessage.upto_amount"
              class="error-message"
            >
              {{ errorMessage.upto_amount[0] }}
            </p>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Remarks"
            label-for="remarks"
          >
            <b-form-textarea
              id="remarks"
              v-model="remarks"
              rows="3"
              placeholder="Remarks"
            />
            <p
              v-if="errorMessage && errorMessage.remarks"
              class="error-message"
            >
              {{ errorMessage.remarks[0] }}
            </p>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group
            label="Sent Through"
            label-for="sentThrough"
          >
            <custom-v-select
              id="sentThrough"
              v-model="sentThrough"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sentThroughOptions"
              label="text"
              @input="onSentThroughChange"
            />
            <p
              v-if="errorMessage && errorMessage.sent_through"
              class="error-message"
            >
              {{ errorMessage.sent_through[0] }}
            </p>
          </b-form-group>
        </b-col>

        <!-- Courier related fields -->
        <template v-if="sentThrough && sentThrough.value === 'courier'">
          <b-col cols="6">
            <b-form-group
              label="Courier"
              label-for="courier"
            >
              <custom-v-select
                id="courier"
                v-model="selectedCourier"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="courierOptions"
                label="text"
              />
              <p
                v-if="errorMessage && errorMessage.courier"
                class="error-message"
              >
                {{ errorMessage.courier[0] }}
              </p>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <label for="courier-date">Courier Date</label>
            <b-form-datepicker
              id="courier-date"
              v-model="courierDate"
              menu-class="w-100"
              calendar-width="100%"
            />
            <p
              v-if="errorMessage && errorMessage.courier_date"
              class="error-message"
            >
              {{ errorMessage.courier_date[0] }}
            </p>
          </b-col>

          <b-col cols="6">
            <b-form-group
              label="Delivery Boy"
              label-for="deliveryBoy"
            >
              <custom-v-select
                id="deliveryBoy"
                v-model="selectedDeliveryBoy"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="deliveryBoyOptions"
                label="text"
              />
              <p
                v-if="errorMessage && errorMessage.delivery_boy"
                class="error-message"
              >
                {{ errorMessage.delivery_boy[0] }}
              </p>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group
              label="Courier Slip"
              label-for="courierSlip"
            >
              <b-form-file
                id="courierSlip"
                v-model="courierSlip"
                accept=".pdf,.doc,.docx,.jpg,.png"
                placeholder="Choose courier slip file..."
              />
              <p
                v-if="errorMessage && errorMessage.courier_slip"
                class="error-message"
              >
                {{ errorMessage.courier_slip[0] }}
              </p>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Docket Number"
              label-for="docketNumber"
            >
              <b-form-input
                id="docketNumber"
                v-model="docketNumber"
                type="text"
                placeholder="Docket Number"
              />
              <p
                v-if="errorMessage && errorMessage.docket_number"
                class="error-message"
              >
                {{ errorMessage.docket_number[0] }}
              </p>
            </b-form-group>
          </b-col>
        </template>

        <!-- MR related fields -->
        <template v-if="sentThrough && sentThrough.value === 'MR'">

          <b-col cols="6">
            <b-form-group
              label="MR Name"
              label-for="mr"
              :state="mrValidationState"
            >
              <b-form-input
                id="mr"
                v-model="mr"
                type="text"
                placeholder="Enter MR Name"
                :state="mrValidationState"
                @input="onMrNameInput"
              />
              <b-form-invalid-feedback>
                {{ mrErrorMessage }}
              </b-form-invalid-feedback>
              <p
                v-if="errorMessage && errorMessage.mr"
                class="error-message"
              >
                {{ errorMessage.mr[0] }}
              </p>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="MR Mobile No."
              label-for="mr_mobile"
              :state="mrMobileValidationState"
            >
              <b-form-input
                id="mr_mobile"
                v-model="mrMobile"
                type="text"
                placeholder="Enter 10 digit mobile number"
                maxlength="10"
                :state="mrMobileValidationState"
                @input="onMrMobileInput"
              />
              <b-form-invalid-feedback>
                {{ mrMobileErrorMessage }}
              </b-form-invalid-feedback>
              <p
                v-if="errorMessage && errorMessage.mr_mobile"
                class="error-message"
              >
                {{ errorMessage.mr_mobile[0] }}
              </p>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <label for="mr-handover-date">Mr Handover Date</label>
            <b-form-datepicker
              id="mr-handover-date"
              v-model="mrHandoverDate"
              menu-class="w-100"
              calendar-width="100%"
            />
            <p
              v-if="errorMessage && errorMessage.mr_handover_date"
              class="error-message"
            >
              {{ errorMessage.mr_handover_date[0] }}
            </p>
          </b-col>
        </template>

      </b-row>

    </b-form>
    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="secondary"
        @click="cancel()"
      >
        Cancel
      </b-button>
      <b-button
        variant="primary"
        :disabled="saving"
        @click="ok()"
      >
        Create
        <b-spinner
          v-if="saving"
          small
          label="Small Spinner"
        />
      </b-button>

    </template>
  </b-modal>

</template>

<script>
import {
  BModal, BRow, BCol, BFormGroup, BButton, BFormInput, BFormDatepicker, BForm, BSpinner, BAlert, BFormTextarea, BFormFile, BFormInvalidFeedback,
} from 'bootstrap-vue'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    CustomVSelect,
    BModal,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormDatepicker,
    BButton,
    BSpinner,
    BAlert,
    BFormTextarea,
    BFormFile,
    BFormInvalidFeedback,
  },

  data() {
    return {
      showModal: true,
      selectedSupplier: null,
      supplierOptions: [],
      noCheques: 1,
      defaultChequeNumber: null,
      issueDate: new Date().toISOString().split('T')[0],
      amount: null,
      docketNumber: null,
      uptoAmount: null,
      remarks: '',
      sentThrough: null,
      sentThroughOptions: [
        { value: 'courier', text: 'Courier' },
        { value: 'MR', text: 'MR' },
      ],
      selectedCourier: null,
      courierOptions: [],
      courierDate: null,
      selectedDeliveryBoy: null,
      deliveryBoyOptions: [],
      courierSlip: null,
      mr: null,
      mrHandoverDate: null,
      mrMobile: null,
      saving: false,
      errorMessage: {},
      showValidationErrors: false,
    }
  },
  computed: {
    mrValidationState() {
      if (this.showValidationErrors && this.sentThrough && this.sentThrough.value === 'MR') {
        return !!(this.mr && this.mr.trim().length > 0)
      }
      return null
    },
    mrErrorMessage() {
      if (this.showValidationErrors && this.sentThrough && this.sentThrough.value === 'MR' && (!this.mr || this.mr.trim().length === 0)) {
        return 'MR Name is required'
      }
      return ''
    },
    mrMobileValidationState() {
      if (this.showValidationErrors && this.sentThrough && this.sentThrough.value === 'MR') {
        return !!(this.mrMobile && this.mrMobile.length === 10 && /^\d{10}$/.test(this.mrMobile))
      }
      return null
    },
    mrMobileErrorMessage() {
      if (this.showValidationErrors && this.sentThrough && this.sentThrough.value === 'MR') {
        if (!this.mrMobile || this.mrMobile.length === 0) {
          return 'Mobile number is required'
        }
        if (this.mrMobile.length !== 10 || !/^\d{10}$/.test(this.mrMobile)) {
          return 'Mobile number must be exactly 10 digits'
        }
      }
      return ''
    },
  },
  created() {
    this.fetchOptions()
  },
  methods: {
    fetchOptions() {
      // Fetch suppliers (previously buyers)
      axios.get('/supplier_options')
        .then(res => {
          this.supplierOptions = res.data.data
        })

      // Fetch default cheque number
      axios.get('/accounts/vatika_cheques/latest_cheque_number')
        .then(res => {
          this.defaultChequeNumber = res.data.next_cheque_number
        })

      // Fetch courier options
      axios.get('/returns/courier_options')
        .then(res => {
          this.courierOptions = res.data.data
        })

      // Fetch delivery boy options
      axios.get('/accounts/salesmans_options')
        .then(res => {
          this.deliveryBoyOptions = res.data.data
        })
    },
    onSentThroughChange() {
      // Reset related fields when sent through changes
      this.selectedCourier = null
      this.courierDate = null
      this.selectedDeliveryBoy = null
      this.courierSlip = null
      this.docketNumber = null
      this.mr = null
      this.mrMobile = null
      this.mrHandoverDate = null
      this.showValidationErrors = false
    },
    onMrNameInput(value) {
      // Convert to uppercase automatically
      this.mr = value.toUpperCase()
    },
    onMrMobileInput(value) {
      // Only allow numeric input and limit to 10 digits
      const numericValue = value.replace(/\D/g, '')
      this.mrMobile = numericValue.slice(0, 10)
    },
    submitHandler(event) {
      event.preventDefault()
      this.showValidationErrors = true

      // Validate MR fields if MR is selected
      if (this.sentThrough && this.sentThrough.value === 'MR') {
        if (!this.mr || this.mr.trim().length === 0) {
          this.saving = false
          return
        }
        if (!this.mrMobile || this.mrMobile.length !== 10 || !/^\d{10}$/.test(this.mrMobile)) {
          this.saving = false
          return
        }
      }

      const formData = new FormData()

      // Required fields
      formData.append('no_of_cheques', this.noCheques)

      if (this.selectedSupplier) {
        formData.append('supplier', this.selectedSupplier.id)
      }

      if (this.issueDate) {
        formData.append('issue_date', this.issueDate)
      }

      // Amount fields only for single cheque
      if (this.noCheques === 1) {
        if (this.amount) {
          formData.append('amount', +this.amount)
        }
        if (this.uptoAmount) {
          formData.append('upto_amount', +this.uptoAmount)
        }
      } else {
        formData.append('amount', 0)
        formData.append('upto_amount', 0)
      }

      formData.append('remarks', this.remarks || '')
      formData.append('docket_number', this.docketNumber || '')

      // Sent through related fields
      if (this.sentThrough) {
        formData.append('sent_through', this.sentThrough.value)

        if (this.sentThrough.value === 'courier') {
          if (this.selectedCourier) {
            formData.append('courier', this.selectedCourier.id)
          }
          if (this.courierDate) {
            formData.append('courier_date', this.courierDate)
          }
          if (this.selectedDeliveryBoy) {
            formData.append('delivery_boy', this.selectedDeliveryBoy.id)
          }
          if (this.courierSlip) {
            formData.append('courier_slip', this.courierSlip)
          }
          formData.append('docket_number', this.docketNumber || '')
        } else if (this.sentThrough.value === 'MR') {
          if (this.mr) {
            formData.append('mr', this.mr)
          }
          if (this.mrHandoverDate) {
            formData.append('mr_handover_date', this.mrHandoverDate)
          }
          if (this.mrMobile) {
            formData.append('mr_mobile', this.mrMobile)
          }
        }
      }

      this.saving = true
      axios.post('/accounts/vatika_cheques/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message || 'Cheque Created',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })

          this.$emit('cheque-added')
          this.saving = false
        }).catch(error => {
          this.errorMessage = error?.response?.data || 'Something went wrong'
          this.saving = false
        })
    },
  },
}

</script>

<style scoped>
.error-message {
  color: red
}
</style>
